import { Injectable } from "@angular/core";
import { ApiService, IPHelper } from "@nrwl/common-lib";
import { Observable } from 'rxjs';
import { DISCOVERY_TYPES } from "../components/datasource.entity.widget/models/types";

@Injectable({
  providedIn: 'root'
})
export class JmepDiscoverService {
  defaultTimeToWait = "5";
  activatedCount = 0;
  processedCount = 0;
  errorCount = 0;
  errorRowCount = 0;
  ipAssignedCount = 0;
  discoveryData = [];
  discoveryErrorMessage = null;
  autoConfigData = {};
  isAutoAssignIPEnabled = false;
  selectedEsam = null;
  factoryDefaultOption = "Use existing value";
  loopbackInterface = [
    { name: "useExistingValue", value: this.factoryDefaultOption},
    { name: "disabled", value: "Disabled" },
    { name: "port", value: "Port" },
    { name: "source", value: "Source specific" },
  ];
  ARPOptions = [
    { name: "useExistingValue", value: this.factoryDefaultOption},
    { name: "enableNetworkInterface", value: "Enable Network Interface" },
    { name: "enableEquipmentInterface", value: "Enable Equipment Interface"},
    { name: "enableBothInterface", value: "Enable Both Interfaces" }
  ];
  dyingGaspOptions = [
    { name: "useExistingValue", value: this.factoryDefaultOption},
    { name: "disabled", value: "Disabled" },
    { name: "enableNetworkInterface", value: "Enable Network Interface" },
    { name: "enableEquipmentInterface",value: "Enable Equipment Interface"}
  ];
  timingMode = [
    { name: "useExistingValue", value: this.factoryDefaultOption},
    { name: "asynchronous", value: "Asynchronous" },
    { name: "synchronous", value: "Synchronous" }
  ];
  discoveryTableDimension = [
    { name: "normal", value: "normalDiscoveryResTable"},
    { name: "IP-1", value: "broadcastDiscoveryResTable" },
    { name: "IP-1-auto-config", value: "autoConfigDiscoveryResTable"}
  ];
  subnetIPscountObj = [
    { subnet: "30", normalCount: 2, broadCastCount: 64 },
    { subnet: "29", normalCount: 6, broadCastCount: 32 },
    { subnet: "28", normalCount: 14, broadCastCount: 16 },
    { subnet: "27", normalCount: 30, broadCastCount: 8 },
    { subnet: "26", normalCount: 62, broadCastCount: 4 },
    { subnet: "25", normalCount: 126, broadCastCount: 2 },
    { subnet: "24", normalCount: 254, broadCastCount: 1 }
  ];
  discoveryStates = [
    {
      title: "Discovered",
      count: 0,
      stateClass: "succeeded"
    },
    {
      title: "Activated",
      count: 0,
      stateClass: "succeeded"
    },
    {
      title: "Processed",
      count: 0,
      stateClass: "succeeded"
    },
    {
      title: 'Auto configured',
      count: 0,
      stateClass: "succeeded"
    },
    {
      title: "Error",
      count: 0,
      stateClass: "failed"
    }
  ];
  getJMEPDiscoveryPath = '/uicomm/getJMEPDiscovery';
  setJMEPDiscoveryPath = '/uicomm/setJMEPDiscovery';
  getDiscoveryStatusPath = '/uicomm/discoveryStatusMessage';
  getDiscoveryResultPath = '/uicomm/discoveryResult';
  getZTPDiscoveryPath = '/uicomm/getZTPDiscovery';
  removeZTPDiscoveryPath = '/uicomm/removeZTPDiscovery';
  saveJMEPAutoConfigurationPath = '/uicomm/saveJMEPAutoConfiguration';
  getJMEPAutoConfigurationPath = '/uicomm/getJMEPAutoConfiguration';
  constructor(
    private readonly apiService: ApiService
  ) {}

  // eslint-disable-next-line
  setSelectedEsamInfo(esamInfo: any): void {
    this.selectedEsam = esamInfo;
  }

  // eslint-disable-next-line
  getSelectedEsamInfo(): any {
    return this.selectedEsam;
  }

  // eslint-disable-next-line
  setDiscoveryData(res: any): void {
    this.discoveryData = res;
  }

  // eslint-disable-next-line
  getDiscoveryData(): any{
    return this.discoveryData;
  }

  // eslint-disable-next-line
  setAutoConfigData(data: any): void {
    this.autoConfigData = data;
  }

  // eslint-disable-next-line
  getAutoConfigData(): any {
    return this.autoConfigData;
  }

  // eslint-disable-next-line
  getLoopbackInterfaceOptions(): any {
    return this.loopbackInterface;
  }

  // eslint-disable-next-line
  getARPoptions(): any {
    return this.ARPOptions;
  }

  // eslint-disable-next-line
  getDyingGaspOptions(): any {
    return this.dyingGaspOptions;
  }

  // eslint-disable-next-line
  getTimingModeOptions(): any {
    return this.timingMode;
  }

  setAutoAssignIPEnabledStatus(flag: boolean): void {
    this.isAutoAssignIPEnabled = flag;
  }

  //eslint-disable-next-line
  getIPBySection(responseData: any, section: string): string {
    let ipSection = "";
    const ipOption = responseData.find(data => data.name === section);
    if(ipOption?.subAttributes) {
      ipSection = ipOption.subAttributes.map(option  =>  option.value).join("\n");
    }
    return ipSection;
  }

  //eslint-disable-next-line
  getTimeToWaitAttributeValue(responseData: any, section: string): string {
    let timeToWait = this.defaultTimeToWait;
    const attribute = responseData.find(data => data.name === section);
    if(attribute.value) {
      timeToWait = attribute.value;
      this.defaultTimeToWait = attribute.value;
    }
    return timeToWait;
  }

  // eslint-disable-next-line
  getDiscoveryStates(mode: string): any {
    switch(mode) {
      case 'discovery':
        return [
          {
            title: "Discovered",
            count: 0,
            stateClass: "green-state"
          },
          {
            title: "Activated",
            count: 0,
            stateClass: "green-state"
          },
          {
            title: "Processed",
            count: 0,
            stateClass: "red-state"
          },
          {
            title: "Error",
            count: 0,
            stateClass: "red-state"
          }
        ];
      case 'broadcastDiscovery':
        return [
          {
            title: "Discovered",
            count: 0,
            stateClass: "green-state"
          },
          {
            title: "Activated",
            count: 0,
            stateClass: "green-state"
          },
          {
            title: "Processed",
            count: 0,
            stateClass: "red-state"
          },
          {
            title: "Auto configured",
            count: 0,
            stateClass: "green-state"
          },
          {
            title: "Error",
            count: 0,
            stateClass: "red-state"
          }
        ];
    }
  }

  clearResultCounts(): void {
    this.errorCount = 0;
    this.activatedCount = 0;
    this.processedCount = 0;
    this.ipAssignedCount = 0;
  }

  // eslint-disable-next-line
  getDiscoveryStatesCount(discoveredCount: number, discoveryType: string): any {
    this.discoveryStates.forEach((status,index) => {
      switch(status.title) {
        case 'Discovered':
          this.discoveryStates[index].count = discoveredCount;
          this.discoveryStates[index].stateClass = (discoveredCount > 0) ? 'succeeded' : 'failed';
          break;
        case 'Activated':
          this.discoveryStates[index].count = this.activatedCount;
          this.discoveryStates[index].stateClass = (discoveredCount === this.activatedCount) ? 'succeeded' : 'failed';
          break;
        case 'Processed':
          this.discoveryStates[index].count = this.processedCount;
          this.discoveryStates[index]['stateClass'] = (discoveredCount === this.processedCount) ? 'succeeded' : 'failed';
          break;
        case 'Auto configured':
          this.discoveryStates[index].count = this.ipAssignedCount;
          this.discoveryStates[index]['stateClass'] = (discoveredCount === this.ipAssignedCount) ? 'succeeded' : 'failed';
          break;
        case 'Error':
          this.discoveryStates[index].count = this.errorCount;
          this.discoveryStates[index]['stateClass'] = (this.discoveryStates[index]['count'] > 0) ? 'failed' : 'succeeded';
          break;
      }
    });
    if(discoveryType === DISCOVERY_TYPES.discovery) {
      const autoConfigIndex = this.discoveryStates.findIndex(field => field.title === 'Auto configured');
      if(autoConfigIndex > 0){
        this.discoveryStates.splice(autoConfigIndex,1);
      }
    }
    return this.discoveryStates;
  }

  // eslint-disable-next-line
  getTableObject(item, mode) {
    this.discoveryErrorMessage = null;
    switch (mode) {
      case "discovery":
        return {
          id: item.probeId,
          ipAddress: item.probeIp,
          probeId: item.probeId,
          equipmentMac: item.equipmentMac ? item.equipmentMac : '',
          activateStatus: this.getActivationStatus(item),
          processState: this.getProcessedStatus(item),
          errorMsg: (this.discoveryErrorMessage === null ? '' : this.discoveryErrorMessage)
        };

      case "broadcastDiscovery":
        return {
          id: item.probeId,
          ipAddress: item.probeIp,
          probeId: item.probeId,
          equipmentMac: item.equipmentMac ? item.equipmentMac : '',
          activateStatus: this.getActivationStatus(item),
          processState: this.getProcessedStatus(item),
          ipAssignStatus: this.getIPAssignedStatus(item),
          errorMsg: (this.discoveryErrorMessage === null ? '' : this.discoveryErrorMessage)
        };
    }
  }

  // eslint-disable-next-line
  getIPAssignedStatus(prob: any): any {
    let ipConfigObj = null;
    if(prob.activationStatus['status'] === 'failed') {
      return {
        label: 'skipped',
        icon: 'mdi-minus',
        customClass: 'none'
      };
    }else {
      if(prob.initialConfigStatus && prob.initialConfigStatus.length > 0 && this.isAutoAssignIPEnabled) {
        for(let i = 0; i < prob.initialConfigStatus.length; i++) {
          if(prob.initialConfigStatus[i].configName === 'jmep-auto-configure') {
            ipConfigObj = prob.initialConfigStatus[i];
          }
        }
        if(ipConfigObj) {
          switch (ipConfigObj.configStatus) {
            case 'succeeded':
              this.ipAssignedCount++;
              return {
                label: 'succeeded',
                icon: 'mdi-check',
                customClass: 'success'
              };
            case 'failed':
              if(this.errorCount === 0) {
                this.errorCount++;
              }
              if(ipConfigObj.subConfigResults) {
                const subConfigs = ipConfigObj.subConfigResults;
                for(let i = 0; i < subConfigs.length; i++) {
                  if(subConfigs[i].configStatus === 'failed') {
                    if(this.discoveryErrorMessage === null) {
                      this.discoveryErrorMessage = subConfigs[i].message;
                    }
                  }
                }
              }else {
                if(this.discoveryErrorMessage === null) {
                  this.discoveryErrorMessage = ipConfigObj.message;
                }
              }
              return {
                label: 'failed',
                icon: 'mdi-close',
                customClass: 'failed',
              };
            case 'skipped':
              return {
                label: 'skipped',
                icon: 'mdi-minus',
                customClass: 'none'
              };
          }
        }
      }
      else {
        return {
          label: 'skipped',
          icon: 'mdi-minus',
          customClass: 'none'
        };
      }
    }
  }

  // eslint-disable-next-line
  getProcessedStatus(prob: any): any {
    let isProcessed = true;
    if(prob.activationStatus['status'] === 'failed') {
      return {
        label: 'skipped',
        icon: 'mdi-minus',
        customClass: 'none'
      };
    }else {
      if(prob.initialConfigStatus && prob.initialConfigStatus.length > 0) {
        for(let i = 0; i < prob.initialConfigStatus.length; i++) {
          if(prob.initialConfigStatus[i].configName !== 'jmep-auto-configure') {
            if(prob.initialConfigStatus[i].configStatus === 'failed') {
              isProcessed = false;
              if(this.discoveryErrorMessage === null) {
                this.discoveryErrorMessage = prob.initialConfigStatus[i]['message'];
              }
              if(this.errorCount === 0) {
                this.errorCount++;
              }
              return {
                label: 'failed',
                icon: 'mdi-close',
                customClass: 'failed',
              };
            }
          }
        }
      }else {
        isProcessed = false;
        return {
          label: 'skipped',
         icon: 'mdi-minus',
          customClass: 'none'
        };
      }
    }
    if(isProcessed) {
      this.processedCount++;
      return {
        label: 'succeeded',
        icon: 'mdi-check',
        customClass: 'success'
      };
    }
  }

  // eslint-disable-next-line
  getActivationStatus(prob: any): any {
    switch (prob.activationStatus['status']) {
      case 'succeeded':
        this.activatedCount++;
        return {
          label: 'succeeded',
          icon: 'mdi-check',
          customClass: 'success'
        };
      case 'failed':
        if(this.discoveryErrorMessage === null) {
          this.discoveryErrorMessage = prob.activationStatus['message'];
        }
        return {
          label: 'failed',
          icon: 'mdi-close',
          customClass: 'failed',
        };
      case 'skipped':
        return {
          label: 'skipped',
          icon: 'mdi-minus',
          customClass: 'none'
        };
    }
  }

  // eslint-disable-next-line
  validateTimeRange(time: any, range: string, allowBlank: boolean): string{
    const rs = range.split('-');
    let msg = null;
    let num = time;
    if( ((typeof num === 'undefined') || (num === null) || (num === '')) && allowBlank === false ){
      msg = 'Field cannot be empty.';
    }else {
      if( isNaN(num)) {  // alpha not numeric
        msg = 'A number must be provided.';
      } else if (num % 1 !== 0) {  // not a whole number
        msg = 'A whole number must be provided.';
      } else if(num) {
        num = parseInt(num,10);
        if ((num < parseInt(rs[0],10)) || (num >parseInt(rs[1],10))) {
          msg = 'Valid range is a whole number between ' + rs[0] + ' and ' + rs[1];
        }
      }
    }
    return msg;
  }

  getTransmitDuration(ipCounts: number): number {
    let duration = 5;
    if(ipCounts > 50  && ipCounts <= 100) {
      duration = 10;
    }
    else if(ipCounts > 100  && ipCounts <= 150) {
      duration = 15;
    }
    else if(ipCounts > 150  && ipCounts <= 300) {
      duration = 20;
    }
    else if(ipCounts > 300  && ipCounts <= 400) {
      duration = 25;
    }
    else if(ipCounts > 400) {
      duration = 30;
    }
    return duration;
  }

  isValidIPv4ClassCCIDR(address: string): boolean {
    if (address !== undefined && address !== null) {
      return IPHelper.isValidIPv4ClassCCIDR(address);
    }
    else {
      return false;
    }
  }

  isValidIpRange(address: string): any {
    if (address !== undefined && address !== null) {
      return IPHelper.isValidIpRange(address);
    }
    else {
      return false;
    }
  }

  getNumberOfIPsInRange(startIP: string, endIP: string): number {
    const ipList = this.getIPv4AddressesInRange(startIP, endIP);
    return ipList.length;
  }

 // eslint-disable-next-line
  getIPv4AddressesInRange(startIP, endIP) {
    const ip1v4 = IPHelper.getIPv4(startIP);
    const ip2v4 = IPHelper.getIPv4(endIP);
    return this.getRangev4(ip1v4, ip2v4);
  }

   // eslint-disable-next-line
  getRangev4(ip1, ip2){
    const ips = [];
    let firstAddressLong = this.toLong(ip1);
    const lastAddressLong = this.toLong(ip2);
    const totalIPs = lastAddressLong - firstAddressLong;

    for(firstAddressLong; firstAddressLong <= lastAddressLong; firstAddressLong++){
      ips.push(this.fromLong(firstAddressLong));
    }
    return ips;
  }

  toLong(ip: string): any {
    let ipl = 0;
    ip.split('.').forEach((octet) => {
      ipl <<= 8;
      ipl += parseInt(octet);
    });
    return (ipl >>> 0);
  }

  // eslint-disable-next-line
  fromLong(ipl: any): any {
    return (`${ipl >>> 24}.${
      ipl >> 16 & 255}.${
      ipl >> 8 & 255}.${
      ipl & 255}`);
  }

  //eslint-disable-next-line
  getJMEPDiscovery(params: any): Observable<any> {
    return this.apiService.post$<any>(`${this.getJMEPDiscoveryPath}`, params);
  }

  //eslint-disable-next-line
  setJMEPDiscovery(params: any): Observable<any> {
    return this.apiService.post$<any>(`${this.setJMEPDiscoveryPath}`, params);
  }

  //eslint-disable-next-line
  discoveryStatusMessage(jobID: string): Observable<any> {
    const statusObj  = {
      "id":jobID
    }
    return this.apiService.post$<any>(`${this.getDiscoveryStatusPath}`, { jobID: statusObj});
  }

  //eslint-disable-next-line
  getDiscoveryResult(jobID: any): Observable<any> {
    const statusObj  = {
      "id":jobID
    }
    return this.apiService.post$<any>(`${this.getDiscoveryResultPath}`, { jobID: statusObj});
  }

  //eslint-disable-next-line
  getZTPDiscovery(params: any): Observable<any> {
    return this.apiService.post$<any>(`${this.getZTPDiscoveryPath}`, params);
  }

  //eslint-disable-next-line
  removeZTPDiscovery(params: any): Observable<any> {
    return this.apiService.post$<any>(this.removeZTPDiscoveryPath, params)
  }

  //eslint-disable-next-line
  getIpList(dataList: any): any {
    return dataList.replace(/ +/g, "").split("\n").filter(data => data);
  }

  //eslint-disable-next-line
  saveJMEPAutoConfiguration(config: any): Observable<any> {
    return this.apiService.post$<any>(this.saveJMEPAutoConfigurationPath, config);
  }

  getJMEPAutoConfiguration(): Observable<any> {
    return this.apiService.post$<any>(this.getJMEPAutoConfigurationPath);
  }

}
